"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m11.81 16a.47.47 0 0 0 .4 0l11.49-5a.5.5 0 1 0 -.4-.92l-11.3 4.92-11.28-5a.51.51 0 0 0 -.66.26c-.32.79.2.67 11.75 5.74z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.3 13-11.3 5-11.28-5a.5.5 0 1 0 -.4.92l11.49 5a.47.47 0 0 0 .4 0l11.49-4.92a.5.5 0 1 0 -.4-.92z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.3 16-11.3 5-11.28-5a.5.5 0 1 0 -.4.91l11.49 5a.51.51 0 0 0 .4 0l11.49-4.91a.5.5 0 1 0 -.4-.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.32 8 11.49 5a.55.55 0 0 0 .4 0l11.49-5a.5.5 0 0 0 0-.91l-11.49-5a.55.55 0 0 0 -.4 0l-11.49 4.96a.5.5 0 0 0 0 .95z"
  })));
};

exports["default"] = _default;